import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { SunIcon, ExternalLinkIcon } from 'lucide-react';
export function Solar() {
  return <div className="space-y-6" data-id="element-2002" data-mp="2iz18j10ze73z">
      <header className="mb-6" data-id="element-2003" data-mp="24ay1dob7cpdl">
        <div className="flex items-center gap-3 mb-2" data-id="element-2004" data-mp="249wqbju6s2vv">
          <div className="p-3 bg-amber-100 rounded-xl" data-id="element-2005" data-mp="2493omxa343kl">
            <SunIcon className="w-6 h-6 text-amber-700" data-id="element-2006" data-mp="298q2n8xqlnug" />
          </div>
          <div data-id="element-2007" data-mp="1va07vzye4099">
            <h1 className="text-4xl font-bold text-stone-900" data-id="element-2008" data-mp="1v970cwrlx6q2">Solar</h1>
            <p className="text-stone-600" data-id="element-2009" data-mp="1zcczzlk7rznk">Solar.dk regnskabssystem</p>
          </div>
        </div>
      </header>

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.5
    }} className="bg-white rounded-2xl border border-stone-200 shadow-sm overflow-hidden" data-id="element-2010" data-mp="1lcvk5vowbwqc">
        {/* Header with link */}
        <div className="p-4 border-b border-stone-200 bg-stone-50 flex items-center justify-between" data-id="element-2011" data-mp="3kn3o6750pr7b">
          <div className="flex items-center gap-2" data-id="element-2012" data-mp="g4nbzujoffvd">
            <SunIcon className="w-5 h-5 text-amber-600" data-id="element-2013" data-mp="b6luhe1wfom0" />
            <span className="font-medium text-stone-900" data-id="element-2014" data-mp="b5u6opejmv6a">Solar.dk</span>
          </div>
          <a href="https://solar.dk" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 text-sm text-teal-600 hover:text-teal-700 transition-colors" data-id="element-2015" data-mp="p1610vosejmo">
            Åbn i nyt vindue
            <ExternalLinkIcon className="w-4 h-4" data-id="element-2016" data-mp="3ofi6i6kkijlw" />
          </a>
        </div>

        {/* Iframe container - MUCH BIGGER */}
        <div className="relative w-full" style={{
        height: 'calc(100vh - 200px)'
      }} data-id="element-2017" data-mp="66hc1ihfkjt5">
          <iframe src="https://solar.dk" title="Solar.dk" className="w-full h-full border-0" sandbox="allow-same-origin allow-scripts allow-popups allow-forms" loading="lazy" data-id="element-2018" data-mp="1hnh5wijff6pa" />
        </div>
      </motion.div>

      {/* Info box - smaller and more subtle */}
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      delay: 0.2,
      duration: 0.5
    }} className="bg-amber-50 border border-amber-200 rounded-lg p-3" data-id="element-2019" data-mp="f99txfeujd4q">
        <p className="text-xs text-amber-900" data-id="element-2020" data-mp="3nrpf9m4ooq0b">
          <strong data-id="element-2021" data-mp="3rrgd29smo6ec">Bemærk:</strong> Dette er en indlejret visning af Solar.dk.
          For fuld funktionalitet kan du åbne siden i et nyt vindue ved at
          klikke på linket ovenfor.
        </p>
      </motion.div>
    </div>;
}